import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function HotComics() {
  const hotComics = [...comics].sort((a, b) => b.viewCount - a.viewCount).slice(0, 6);

  return (
    <section className="w-full" aria-label="热门漫画">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-1">
              热门漫画
            </h2>
            <p className="text-foreground-500 text-sm">千万读者共同选择，品质有保障</p>
          </div>
          <Link
            to="/category/all"
            className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {hotComics.map((comic) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="group cursor-pointer"
            >
              <div className="relative aspect-[3/4] rounded-lg overflow-hidden mb-3 bg-background-200">
                <img
                  src={comic.coverImage}
                  alt={comic.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-2 left-2">
                  <span className="px-2 py-0.5 rounded-full bg-primary-500 text-background-50 text-xs font-medium">
                    {comic.rating}
                  </span>
                </div>
                {comic.status === '连载中' && (
                  <div className="absolute top-2 right-2">
                    <span className="px-2 py-0.5 rounded-full bg-accent-500 text-background-50 text-xs">
                      连载
                    </span>
                  </div>
                )}
              </div>
              <h3 className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors line-clamp-1">
                {comic.title}
              </h3>
              <p className="text-xs text-foreground-400 mt-0.5">{comic.author}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}